/*
 * DATA_RIGHTS: HONEYWELL CONFIDENTIAL AND PROPRIETARY
 * THIS WORK CONTAINS VALUABLE CONFIDENTIAL AND PROPRIETARY
 * INFORMATION. DISCLOSURE, USE OR REPRODUCTION OUTSIDE OF
 * HONEYWELL INTERNATIONAL, INC. IS PROHIBITED EXCEPT AS
 * AUTHORIZED IN WRITING. THIS UNPUBLISHED WORK IS PROTECTED BY
 * THE LAWS OF THE UNITED STATES AND OTHER COUNTRIES. IN THE
 * EVENT OF PUBLICATION, THE FOLLOWING NOTICE SHALL APPLY:
 * Copyright (C) 2022 HONEYWELL INTERNATIONAL, INC., ALL RIGHTS RESERVED.
 *
 * Created by H144765 on 3/30/2022.
 */

import {actuatorUrl, apiUrl, handleApiCall, securedApiOptions} from './HttpUtils'

export const refreshSpringConfiguration = () => {
    const opts = {method: 'POST'}
    return handleApiCall(actuatorUrl(`refresh`), opts)
}

const getAppConfigsApiUrl = () => {
    return apiUrl(`/appConfigs`)
}

const getLdiImportApiUrl = () => {
    return apiUrl(`/ldiImport`)
}

export const fetchAppConfigs = (ldiId) => {
    const opts = securedApiOptions()
    return handleApiCall(getAppConfigsApiUrl() + '?ldiId=' + ldiId, opts)
}

export const updateAppConfigs = (ldiId, appConfigData) => {
    const opts = securedApiOptions()
    opts.method = 'PUT'
    opts.body = JSON.stringify(appConfigData)
    return handleApiCall(getAppConfigsApiUrl() + '?ldiId=' + ldiId, opts)
}

export const fetchLdisInfo = () => {
    const opts = securedApiOptions()
    return handleApiCall(getAppConfigsApiUrl() + '/ldis', opts)
}

export const submitPassword = (ldiId, password) => {
    const opts = securedApiOptions()
    opts.method = 'POST'
    opts.body = password
    return handleApiCall(getAppConfigsApiUrl() + '/submitPassword' + '?ldiId=' + ldiId, opts)
}

export const isAdminConnectionEnabled = () => {
    const opts = securedApiOptions()
    opts.method = 'GET'
    return handleApiCall(getAppConfigsApiUrl() + '/isAdminConnectionEnabled', opts)
}

export const setAdminConnection = (userName, password) => {
    const opts = securedApiOptions()
    opts.method = 'PUT'
    opts.body = password
    return handleApiCall(getAppConfigsApiUrl() + '/setAdminConnection' + '?userName=' + userName, opts)
}

export const checkAdminConnection = () => {
    const opts = securedApiOptions()
    opts.method = 'GET'
    return handleApiCall(getAppConfigsApiUrl() + '/checkAdminConnection', opts)
}

export const testConnection = (ldiId) => {
    const opts = securedApiOptions()
    return handleApiCall(getAppConfigsApiUrl() + '/testKmsConnection' + '?ldiId=' + ldiId, opts)
}

export const testConnectionAll = () => {
    const opts = securedApiOptions
    return handleApiCall(getAppConfigsApiUrl() + '/testKmsConnectionAll', opts)
}

export const requestLdiImportAvailability = (ldiId) => {
    const opts = securedApiOptions()
    return handleApiCall(getLdiImportApiUrl() + '?ldiId=' + ldiId, opts)
}

export const requestLdiImportFromKms = (ldiId, radioValue) => {
    const opts = securedApiOptions()
    opts.method = 'PUT'
    opts.body = radioValue
    return handleApiCall(getLdiImportApiUrl() + '/update' + '?ldiId=' + ldiId, opts)
}

export const requestRevertOptions = (ldiId) => {
    const opts = securedApiOptions()
    return handleApiCall(getLdiImportApiUrl() + '/revert' + '?ldiId=' + ldiId, opts)
}

export const setRevertOption = (ldiId, revertOption) => {
    const opts = securedApiOptions()
    opts.method = 'PUT'
    opts.body = revertOption
    return handleApiCall(getLdiImportApiUrl() + '/revert' + '?ldiId=' + ldiId, opts)
}

export const requestMemoryRequirements = (ldiId, flag) => {
    const opts = securedApiOptions()
    opts.method = 'PUT'
    return handleApiCall(getLdiImportApiUrl() + '/memoryRequirements' + '?ldiId=' + ldiId + '&flag=' + flag, opts)
}

export const checkCorruptionOfDatabases = () => {
    const opts = securedApiOptions()
    return handleApiCall(getLdiImportApiUrl() + '/checkCorruption', opts)
}

export const fetchLdiNamesAndIds = () => {
    return handleApiCall(getAppConfigsApiUrl() + '/ldiNamesAndIds')
}

export const LdiImportAvailabilityResult = {
    LDI_IMPORT_UPDATE_AVAILABLE: 'LDI_IMPORT_UPDATE_AVAILABLE',
    LDI_IMPORT_CURRENT_LDI_VERSION_ERROR: 'LDI_IMPORT_CURRENT_LDI_VERSION_ERROR',
    LDI_IMPORT_NEW_LDI_VERSION_ERROR: 'LDI_IMPORT_NEW_LDI_VERSION_ERROR',
    LDI_IMPORT_KMS_PROCESSING_ERROR: 'LDI_IMPORT_KMS_PROCESSING_ERROR',
    LDI_IMPORT_KMS_RESPONSE_FAILURE: 'LDI_IMPORT_KMS_RESPONSE_FAILURE',
    LDI_IMPORT_NO_UPDATE_NEEDED: 'LDI_IMPORT_NO_UPDATE_NEEDED',
}

export const LdiImportUpdateResult = {
    LDI_IMPORT_UPDATE_NOT_AVAILABLE: 'LDI_IMPORT_UPDATE_NOT_AVAILABLE',
    LDI_IMPORT_UPDATE_DOWNLOAD_ERROR: 'LDI_IMPORT_UPDATE_DOWNLOAD_ERROR',
    LDI_IMPORT_UPDATE_UNZIPPING_ERROR: 'LDI_IMPORT_UPDATE_UNZIPPING_ERROR',
    LDI_IMPORT_UPDATE_RESTORING_ERROR: 'LDI_IMPORT_UPDATE_RESTORING_ERROR',
    LDI_IMPORT_UPDATE_IMPORTING_OF_DATA_ERROR: 'LDI_IMPORT_UPDATE_IMPORTING_OF_DATA_ERROR',
    LDI_IMPORT_UPDATE_VALIDATION_OF_SCHEMA_FAILED: 'LDI_IMPORT_UPDATE_VALIDATION_OF_SCHEMA_FAILED',
    LDI_IMPORT_UPDATE_INCORRECT_DATABASE_SCHEMA: 'LDI_IMPORT_UPDATE_INCORRECT_DATABASE_SCHEMA',
    LDI_IMPORT_UPDATE_PROCESSING_VERSION_ERROR: 'LDI_IMPORT_UPDATE_PROCESSING_VERSION_ERROR',
    LDI_IMPORT_UPDATE_SUCCESS: 'LDI_IMPORT_UPDATE_SUCCESS',
}

export const LdiImportRevertResult = {
    LDI_IMPORT_REVERT_SUCCESS: 'LDI_IMPORT_REVERT_SUCCESS',
    LDI_IMPORT_REVERT_VERSION_NOT_EXISTING: 'LDI_IMPORT_REVERT_VERSION_NOT_EXISTING',
    LDI_IMPORT_REVERT_BACKUP_ERROR: 'LDI_IMPORT_REVERT_BACKUP_ERROR',
    LDI_IMPORT_REVERT_VERSION_CONVERSION_ERROR: 'LDI_IMPORT_REVERT_VERSION_CONVERSION_ERROR',
    LDI_IMPORT_REVERT_LDI_SCHEMA_ERROR: 'LDI_IMPORT_REVERT_LDI_SCHEMA_ERROR',
    LDI_IMPORT_REVERT_APP_SCHEMA_ERROR: 'LDI_IMPORT_REVERT_APP_SCHEMA_ERROR',
    LDI_IMPORT_REVERT_NO_INFORMATION: 'LDI_IMPORT_REVERT_NO_INFORMATION',
    LDI_IMPORT_REVERT_LDI_REVERT_FAILED: 'LDI_IMPORT_REVERT_LDI_REVERT_FAILED',
    LDI_IMPORT_REVERT_APP_REVERT_FAILED: 'LDI_IMPORT_REVERT_APP_REVERT_FAILED',
}

export const DatabaseType = {
    LDI: 'LDI',
    APP: 'APP',
    UNKNOWN: 'UNKNOWN',
}